export default () => ({
    isActive: false,

    handleDocumentClick(event) {
        if (!this.$root.contains(event.target)) {
            this.isActive = false
        }
    },

    handleButtonClick(event) {
        if (!this.isActive) {
            event.preventDefault()

            this.isActive = true
        }
    },

    onTransitionEnd() {
        if (this.isActive) {
            this.$refs.input.focus()
        }
    },

    init() {
        const boundHandleDocumentClick = this.handleDocumentClick.bind(this)

        document.addEventListener('click', boundHandleDocumentClick)
    },
})
